import { render, staticRenderFns } from "./FlvPlayer.vue?vue&type=template&id=5d6fa0f3&scoped=true&"
import script from "./FlvPlayer.vue?vue&type=script&lang=js&"
export * from "./FlvPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FlvPlayer.vue?vue&type=style&index=0&id=5d6fa0f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6fa0f3",
  null
  
)

export default component.exports